import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { apiRequest, API_CONSTANTS} from '../libs/apiRequest';
import GoogleButton from 'react-google-button'
import { useNavigate } from 'react-router-dom';
import '../css/gtc-login.css';

function GTCLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => {
            handleRequestUserInfo(codeResponse);
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    const handleRequestUserInfo = async (codeResponse: any) => {
        try {
            const form = new FormData();

            Object.keys(codeResponse).map((key) => {
                form.append(key, codeResponse[key]);
            });

            const response = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PUBLIC_API,
                fn: "sso",
                data: form
            });
            const data = await response
            console.log("handleRequestUserInfo", data)
            if (data && data.status == 200) {
                navigate("/verify");
            } else {
                alert("Something went wrong. Check your loging credentials.")
                navigate("/login")
            }
            // window.location.reload();  
        } catch (error) {
            console.log("handleRequestUserInfo", error)
        }
        
    }


    const signin = async () => {
        if (!email || !password) {
            alert("Check input fields!");
            return;
        }

        try {

            const form = new FormData();
            form.append("email", email);
            form.append("password", password);

            const res = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PUBLIC_API,
                fn: "login",
                data: form
            });
            console.log(res);
            if (res && res.status == 200) {
                navigate(res.nextPath);
                // window.location.reload();
            } else {
                alert(res.message || "Check your email address and password.");
            }
        } catch (error) {
            console.log(error);
            alert("Something went wrong. Try again later.");
        }

    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <h1 className="brand-logo">
                            <span className="brand-highlight">Go</span>Trycatch
                        </h1>
                        <h2 className="welcome-text">Welcome back!</h2>
                    </div>

                    <div className="login-form">
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input 
                                className="form-input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Your email address here..."
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <input 
                                className="form-input"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Your password here..."
                            />
                        </div>

                        <a 
                            className="login-button"
                            onClick={signin}
                        >
                            Login
                        </a>

                        <p className="register-text">
                            If you don't have an account yet.{' '}
                            <a href="/register" className="register-link">Register</a>
                        </p>
                    </div>

                    <div className="divider">
                        <div className="divider-line"></div>
                        <span className="divider-text">OR</span>
                        <div className="divider-line"></div>
                    </div>

                    <div className="google-login">
                        <GoogleButton 
                            onClick={() => login()} 
                            style={{ margin: 'auto' }}
                        />
                        <p className="google-text">Sign in now to create your own account</p>
                    </div>
                </div>
            </div>
        </div>
    );
}   

export default GTCLogin;